const GET_USER_CONFIG = 'core/userConfiguration/GET_USER_CONFIG';
const GET_USER_CONFIG_COMPLETED = 'core/userConfiguration/GET_USER_CONFIG_COMPLETED';
const GET_USER_CONFIG_FAILED = 'core/userConfiguration/GET_USER_CONFIG_FAILED';

const PUT_USER_CONFIG = 'core/userConfiguration/PUT_USER_CONFIG';
const PUT_USER_CONFIG_COMPLETED = 'core/userConfiguration/PUT_USER_CONFIG_COMPLETED';
const PUT_USER_CONFIG_FAILED = 'core/userConfiguration/PUT_USER_CONFIG_FAILED';

const PATCH_USER_CONFIG = 'core/userConfiguration/PATCH_USER_CONFIG';
const PATCH_USER_CONFIG_COMPLETED = 'core/userConfiguration/PATCH_USER_CONFIG_COMPLETED';
const PATCH_USER_CONFIG_FAILED = 'core/userConfiguration/PATCH_USER_CONFIG_FAILED';

const DELETE_USER_CONFIG = 'core/userConfiguration/DELETE_USER_CONFIG';
const DELETE_USER_CONFIG_COMPLETED = 'core/userConfiguration/DELETE_USER_CONFIG_COMPLETED';
const DELETE_USER_CONFIG_FAILED = 'core/userConfiguration/DELETE_USER_CONFIG_FAILED';

const RESET_USER_CONFIG = 'core/userConfiguration/RESET_USER_CONFIG';

export {
  GET_USER_CONFIG,
  GET_USER_CONFIG_COMPLETED,
  GET_USER_CONFIG_FAILED,
  PUT_USER_CONFIG,
  PUT_USER_CONFIG_COMPLETED,
  PUT_USER_CONFIG_FAILED,
  PATCH_USER_CONFIG,
  PATCH_USER_CONFIG_COMPLETED,
  PATCH_USER_CONFIG_FAILED,
  DELETE_USER_CONFIG,
  DELETE_USER_CONFIG_COMPLETED,
  DELETE_USER_CONFIG_FAILED,
  RESET_USER_CONFIG
};
